import { computePoolAddress } from '@cryptoalgebra/kim-sdk';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { Address } from '@thirdweb-dev/sdk';
import { useProviderStrategies } from '@app/hooks/plugins/useProviderStrategies';
import { useVaultsByPool } from '@app/hooks/ichi/useVaultsByPool';
import { useGammaVaults } from '@app/hooks/gamma/useGammaVaults';
import { useMemo } from 'react';

export interface LiquidityWizardMinInfo {
  poolAddress: Address | undefined;
  flags: {
    hasStrategies: boolean;
    hasSteerStrategies: boolean;
    hasIchiStrategies: boolean;
    hasGammaStrategies: boolean;
  };
}

export function useDerivedMintInfo() {
  const { currencyA, currencyB } = useLiquidityWizardState();

  const poolAddress =
    currencyA && currencyB
      ? computePoolAddress({
          tokenA: currencyA.wrapped,
          tokenB: currencyB.wrapped
        })
      : undefined;

  const { strategies: steerVaults } = useProviderStrategies(poolAddress);
  const { data: gammaVaults } = useGammaVaults();
  const { data: ichiVaults } = useVaultsByPool(poolAddress);
  const hasSteerStrategies = !!steerVaults?.length;
  const hasIchiStrategies = !!ichiVaults?.length;

  const hasGammaStrategies = useMemo(() => {
    if (!gammaVaults) {
      return false;
    }

    return (
      gammaVaults.filter(
        item => item.pool.toLowerCase() === poolAddress?.toLowerCase()
      ).length > 0
    );
  }, [gammaVaults, poolAddress]);

  const hasStrategies =
    !!steerVaults?.length || !!ichiVaults?.length || hasGammaStrategies;

  return {
    poolAddress,
    flags: {
      hasStrategies,
      hasSteerStrategies,
      hasIchiStrategies,
      hasGammaStrategies
    }
  };
}
